export enum SCHEDULE_TYPE {
  RECURRING = "recurring",
  SPECIFIC_TIME = "specific-time",
}
